<template>
  <v-card width="100%" color="#FFFFFFE6" class="base-card">
    <p class="chart-title-text">{{ inputChartTitle }}</p>
    <p class="red-attention-text">{{ redText }}</p>
    <v-row justify="center" no-gutters>
      <v-card width="90%" color="#fff" flat class="chart-card">
        <v-row justify="center">
          <Chart :fetched-data="fetchedData" :quality-name="qualityName" />
        </v-row>
        <p class="annotation-text">{{ annotationText }}</p>
      </v-card>
    </v-row>

    <v-btn class="close-button" color="#000" @click="closeClickAction" depressed
      >とじる</v-btn
    >
  </v-card>
</template>

<script>
import Chart from "../Molecules/Chart";

export default {
  name: "ChartCard",
  data: () => ({}),
  methods: {
    closeClickAction() {
      this.$emit("closeClickAction");
    }
  },
  components: {
    Chart
  },
  created() {
    console.log("fetchedData", this.fetchedData);
  },
  props: ["fetchedData", "qualityName", "chartTitle"],
  computed: {
    inputChartTitle() {
      if (!this.qualityName) {
        return this.chartTitle;
      } else {
        switch (this.qualityName) {
          case "WT":
            return "今週の水温";
          case "PH":
            return "今週のPH";
          default:
            return "";
        }
      }
    },
    annotationText() {
      switch (this.qualityName) {
        case "WT":
          return "※電気を使いすぎて、大気中のCO2が増えると、水温が上昇して理想の水温から離れ、生態系に影響を及ぼします。";
        case "PH":
          return "※ゴミを分別しなかったり、汚れた水を流したりすると、pH値が変化して理想のpH値から離れ、生態系に影響を及ぼします。";
        default:
          return "";
      }
    },
    redText() {
      switch (this.qualityName) {
        case "WT":
          return "赤色の線は理想の水温（24.5℃）を表しています。";
        case "PH":
          return "赤色の線は理想のPH（8）を表しています。";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
p {
  margin: 0;
}
.base-card {
  box-shadow: 0px 6px 9px #00000029;
  opacity: 1;
  border-radius: 30px;
}
.chart-title-text {
  margin: 0;
  padding: 10px 0;
  color: #000;
  font-weight: bold;
}
.red-attention-text {
  color: red;
  font-weight: bold;
}
.chart-card {
  border-radius: 30px;
  margin: 20px;
  padding: 40px 20px;
}
.close-button {
  height: 26px !important;
  border-radius: 20px;
  font-weight: bold;
  padding: 0 40px !important;
  margin: 20px;
}
.annotation-text {
  text-align: left;
  margin-top: 20px;
  color: #000;
}
@media screen and (max-width: 350px) {
  .red-attention-text {
    font-size: 0.8em;
  }
  .chart-card {
    margin: 10px 0;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  .chart-card {
    margin: 10px 0;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
